import { useFeatureFlagConfig } from "@/entities/config";
import { PropsWithChildren } from "react";
import { FeatureFlagsContext } from "../context";

export function FeatureFlagProvider({ children }: PropsWithChildren) {
    const { data } = useFeatureFlagConfig();
    return <FeatureFlagsContext value={data ?? undefined}>{children}</FeatureFlagsContext>;
}
